
import ModalRequestAccess from '@marketplace/components/modals/ModalRequestAccess.vue'
import ProductQuantity from '@marketplace/components/product/product-quantity.vue'
import ButtonAddToCart from '@marketplace/components/product-page/parts/button-add-to-cart.vue'
import { RETAILER_APPROVAL_STATUS_PENDING } from '@marketplace/config/storefront.js'
import { calculateActualMinimumQuantity } from '@marketplace/helpers/quantity-calculations.js'
import { trackClick } from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
    name: 'ProductCartActions',

    components: {
        ButtonAddToCart,
        ProductQuantity,
    },

    props: {
        hasVariants: {
            type: Boolean,
            default: false,
        },
        isOutOfStock: {
            type: Boolean,
            required: true,
        },
        doesShipToLocale: {
            type: Boolean,
            required: false,
            default: false,
        },
        showQuantityField: {
            type: Boolean,
            default: true,
        },
        price: {
            type: Number,
            required: true,
        },
        currentQuantity: {
            type: Number,
            required: true,
        },
        storefrontId: {
            type: [String, Number],
            required: true,
        },
        listingId: {
            type: [String, Number],
            required: true,
        },
        variantId: {
            type: [String, Number],
            default: '',
        },
        variantIds: {
            type: Object,
            default: null,
        },
        caseQuantity: {
            type: Number,
            default: 1,
        },
        minimumOrderQuantity: {
            type: Number,
            default: 1,
        },
        maxInventory: {
            type: Number,
            default: -1,
        },
        componentSource: {
            type: String,
            default: '',
        },

        trackingCategory: {
            type: String,
            default: '',
        },
        showRequestAccessButton: {
            type: Boolean,
            default: false,
        },
        requestAccessStatus: {
            type: String,
            default: '',
        },
        isFavorite: {
            type: Boolean,
            default: false,
        },
        brandName: {
            type: String,
            default: '',
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const initialQuantity = calculateActualMinimumQuantity(
            this.minimumOrderQuantity,
            this.caseQuantity
        )

        return {
            quantity: initialQuantity,
            hasAccessRequested:
                this.requestAccessStatus === RETAILER_APPROVAL_STATUS_PENDING,
            userErrorMessage: null,
            cartUserErrorMessage: null,
        }
    },

    computed: {
        ...mapGetters('global', [
            'isAccountStatusApproved',
            'accountStatusMessage',
        ]),

        units() {
            if (!this.hasVariants) {
                return this.currentQuantity
            }
            return Object.entries(this.variantIds).reduce((sum, item) => {
                return item[1].quantity + sum
            }, 0)
        },
        addingToCartIsPossible() {
            return this.isAccountStatusApproved && this.doesShipToLocale
        },
        showVariantHint() {
            if (!this.hasVariants) {
                return false
            }
            if (!this.doesShipToLocale || this.isOutOfStock) {
                return false
            }

            const noSingleVariantSelected =
                this.variantId === '' || this.variantId === null
            const noMultiQuantitiesSelected =
                !this.variantIds ||
                Object.values(this.variantIds).every(
                    (item) => (item?.quantity || 0) === 0
                )

            return noSingleVariantSelected && noMultiQuantitiesSelected
        },
    },

    watch: {
        currentQuantity() {
            this.quantity = this.currentQuantity
        },
    },

    mounted() {
        EventBus.$on('hasAccessRequested', this.updateAccessRequestStatus)
        EventBus.$on('userErrorMessage', this.updateUserErrorMessage)
    },

    methods: {
        quantityCallback(newQuantity) {
            if (newQuantity) {
                this.quantity = newQuantity
            }

            this.$emit('selectedQuantity', this.quantity)
        },
        cartSuccess() {
            const resetQuantity = calculateActualMinimumQuantity(
                this.minimumOrderQuantity,
                this.caseQuantity
            )

            this.quantityCallback(resetQuantity)

            this.$emit('addToCartSuccessCallback', {
                subTotal: this.price,
                currency: 'EUR',
                units: this.units,
            })
        },
        showRequestAccessModal() {
            trackClick('Supplier Approval Modal Triggered', {
                category: this.trackingCategory,
            })

            this.$vfm.show({
                component: ModalRequestAccess,
                bind: {
                    storefrontId: this.storefrontId,
                    brandName: this.brandName,
                    trackingCategory: this.trackingCategory,
                },
            })
        },
        updateAccessRequestStatus(data) {
            this.hasAccessRequested = data
        },
        updateUserErrorMessage(data) {
            this.userErrorMessage = data
        },
        cartUserErrorMessageHandler(message) {
            this.cartUserErrorMessage = message
        },
    },
}
